export default function (
    v1: number | string,
    operator: '+' | '-' | '*' | '/',
    v2: number | string
): number | null {
    switch (operator) {
        case '+':
            return Math.floor(Number(v1) + Number(v2));
        case '-':
            return Math.floor(Number(v1) - Number(v2));
        case '*':
            return Math.floor(Number(v1) * Number(v2));
        case '/':
            return Math.floor(Number(v1) / Number(v2));
        default:
            return null;
    }
}
